import { CATEGORY_CHANGE_STAT, CATEGORY_COMPONENT_ID, CATEGORY_STAT_TYPE } from '../base/constants';

export function isChallengeWorkoutId(workoutId: number) {
  return workoutId >= 2000 && workoutId < 3000;
}

export function formatNumberToFixedFraction(num: number, fractionDigits?: number) {
  const multiplier = Math.pow(10, fractionDigits ?? 0);
  const result = Math.trunc(num * multiplier) / multiplier;
  return `${result}`;
}

export function makeExerciseCategoryStatString(categoryGroupId: number) {
  return `${CATEGORY_STAT_TYPE}-${categoryGroupId}-${CATEGORY_COMPONENT_ID}`;
}

export function makeCategoryChangeStatString(categoryGroupId: number) {
  return CATEGORY_CHANGE_STAT.replace('x', `${categoryGroupId}`);
}
